<div>
	<div class="zk-flex zk-gap-2">
		<i class="freud-icon freud-icon-shield-check"></i>
		<p id="compliance-storage-info" freud-typography fontType="smallRegular1-2">
			<ng-container *ngIf="isPsychologist;else other_content"> 
				{{ 'PROMPTUARY.COMPLIANCE.MODAL.STORAGE_INFO.PSYCHOLOGIST' | translate }}
			</ng-container>
			<ng-template #other_content>
				{{ 'PROMPTUARY.COMPLIANCE.MODAL.STORAGE_INFO.OTHER' | translate }}
			</ng-template>

		</p>
	</div>
	<div class="zk-flex zk-gap-2 zk-pt-4">
		<i class="freud-icon freud-icon-users"></i>
		<p id="compliance-individual-access-info" freud-typography fontType="smallRegular1-2" [innerHTML]="'PROMPTUARY.COMPLIANCE.MODAL.ACCESS_INFO.INDIVIDUAL' | translate">		
		</p>
	</div>
	<div class="zk-flex zk-gap-2 zk-pt-4">
		<i class="freud-icon freud-icon-building"></i>
		<p id="compliance-company-access-info" freud-typography fontType="smallRegular1-2" [innerHTML]="'PROMPTUARY.COMPLIANCE.MODAL.ACCESS_INFO.COMPANY' | translate">
		</p>
	</div>
	<div *ngIf="type === 'default'" class="liable-person-info zk-flex zk-gap-2 zk-p-2 zk-mt-4">
		<freud-avatar size="sm" image="/assets/images/karen-silva.png" label="K"></freud-avatar>
		<p id="compliance-liable-person-info" freud-typography fontType="smallRegular1-2" class="liable-person-text">
			{{ 'PROMPTUARY.COMPLIANCE.MODAL.LIABLE_PERSON' | translate }}
		</p>
	</div>
</div>	
